import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
      },
      [
        _createElementVNode("g", { fill: "currentColor" }, [
          _createElementVNode("path", {
            d: "M12.01 2A10 10 0 0 0 2 12.01c0 4.424 2.867 8.169 6.844 9.495.497.099.68-.216.68-.481 0-.232-.017-1.027-.017-1.856-2.784.597-3.364-1.193-3.364-1.193-.448-1.16-1.11-1.458-1.11-1.458-.912-.614.066-.614.066-.614 1.01.067 1.541 1.028 1.541 1.028.895 1.524 2.337 1.094 2.917.828.082-.646.348-1.093.63-1.342-2.221-.232-4.558-1.094-4.558-4.938 0-1.094.398-1.989 1.028-2.685-.1-.248-.448-1.276.099-2.651 0 0 .845-.265 2.75 1.027a9.69 9.69 0 0 1 2.503-.331 9.69 9.69 0 0 1 2.502.331c1.906-1.292 2.751-1.027 2.751-1.027.547 1.375.2 2.403.1 2.651.646.696 1.027 1.591 1.027 2.685 0 3.844-2.336 4.69-4.574 4.938.365.315.68.912.68 1.856 0 1.342-.017 2.42-.017 2.751 0 .265.183.58.68.48 3.977-1.325 6.844-5.07 6.844-9.495C22.018 6.474 17.527 2 12.009 2Z",
          }),
          _createElementVNode("path", {
            d: "M5.795 16.368c-.017.05-.1.066-.166.033s-.116-.1-.083-.15c.017-.05.1-.066.166-.033.066.034.1.1.083.15Zm.397.447c-.05.05-.149.017-.198-.05-.067-.066-.083-.165-.034-.215.05-.05.133-.017.2.05.066.082.082.182.032.215Zm.398.58c-.066.05-.166 0-.215-.083-.067-.083-.067-.199 0-.232.066-.05.165 0 .215.083.066.083.066.182 0 .232Zm.547.563c-.05.067-.166.05-.265-.033-.083-.083-.116-.199-.05-.248.05-.067.166-.05.265.033.083.066.1.182.05.248Zm.746.315c-.017.083-.133.116-.249.083-.116-.033-.182-.132-.166-.199.017-.083.133-.116.25-.083.115.034.181.116.165.2Zm.812.067c0 .082-.1.149-.216.149-.116 0-.215-.067-.215-.15 0-.082.1-.149.215-.149.116 0 .216.067.216.15Zm.762-.133c.017.083-.066.166-.182.182-.116.017-.216-.033-.232-.116-.017-.083.066-.165.182-.182.116-.017.215.033.232.116Z",
          }),
        ]),
      ]
    )
  );
}
